/**
 * Frontend helpers for annotation Slack/Inbox deep links.
 * Paths are always /:teamName/... — never a numeric team id.
 */

export function isNumericTeamId(value) {
  return /^\d+$/.test(String(value || '').trim());
}

export function isAnnotationDeepLink(pathname, search) {
  if (!pathname) return false;
  const analytics = /\/agent-analytics\/(conversations|runs|traces)\/?$/.test(pathname);
  if (!analytics) return false;
  const qs = new URLSearchParams(search || '');
  return qs.get('tab') === 'annotations'
    || qs.has('conversation_id')
    || qs.has('run_id')
    || qs.has('span_id');
}

export function withTeamSlug(pathAndSearch, teamName) {
  const slug = String(teamName || '').trim();
  if (!slug || isNumericTeamId(slug)) return '';
  const encoded = encodeURIComponent(slug);
  const raw = String(pathAndSearch || '');
  const qIndex = raw.indexOf('?');
  const path = qIndex >= 0 ? raw.slice(0, qIndex) : raw;
  const query = qIndex >= 0 ? raw.slice(qIndex) : '';
  const tail = path.replace(/^\/[^/]+/, '') || '';
  return `/${encoded}${tail}${query}`;
}
